import actions from './actions'

// list helper
import ListHelper from '../../utils/listHelper'

// compare function
const compareSameEvent = (a, b) => {
    return a.event_id === b.event_id
}

const initState = {
    events: [],
    textSearch: '',

    total: 0,
    pageSize: 8,
    pageIndex: 1,
    lastTextSearch: '',
    _status: 0,

    selectedEvent: [],
}

const _handleUpdateListEvents = (state, events) => {
    let newEvents = []
    let selectedEvent = state.selectedEvent

    for (let index = 0; index < events.length; index++) {
        let event = {
            ...events[index],
            ...{
                isSelect: ListHelper.checkItemInList(
                    selectedEvent,
                    events[index],
                    compareSameEvent
                ),
            },
        }
        newEvents.push(event)
    }

    return {
        ...state,
        ...{
            events: newEvents,
        },
    }
}

const _handleUpdateSelectEventState = (state, eid, selectState) => {
    let newEvents = []
    const events = state.events
    let selectedEvent = state.selectedEvent

    for (let index = 0; index < events.length; index++) {
        let isSelect = events[index].isSelect
        let event = events[index]
        if (events[index].event_id === eid) {
            isSelect = selectState

            event = {
                ...events[index],
                ...{
                    isSelect,
                },
            }

            // update select list
            if (selectState === true) {
                if (
                    !ListHelper.checkItemInList(
                        selectedEvent,
                        event,
                        compareSameEvent
                    )
                )
                    selectedEvent = selectedEvent.concat(event)
            } else {
                if (
                    ListHelper.checkItemInList(
                        selectedEvent,
                        event,
                        compareSameEvent
                    )
                )
                    selectedEvent = ListHelper.deleteItemInList(
                        selectedEvent,
                        a => compareSameEvent(a, event)
                    )
            }
        }

        newEvents.push(event)
    }

    return {
        ...state,
        ...{
            events: newEvents,
            selectedEvent,
        },
    }
}

const _handleUpdateSelectedEvents = (state, selectedEvent) => {
    let newEvents = []
    let events = state.events

    for (let index = 0; index < events.length; index++) {
        let event = {
            ...events[index],
            ...{
                isSelect: ListHelper.checkItemInList(
                    selectedEvent,
                    events[index],
                    compareSameEvent
                ),
            },
        }
        newEvents.push(event)
    }

    return {
        ...state,
        ...{
            events: newEvents,
            selectedEvent,
        },
    }
}

const reducer = (state = initState, action) => {
    switch (action.type) {
        case actions.type.LOAD_LIST_EVENTS:
            return state

        case actions.type.LOAD_LIST_EVENTS_SUCCESS:
            return _handleUpdateListEvents(state, action.payload.events)

        case actions.type.UPDATE_TEXT_SEARCH:
            return {
                ...state,
                ...{
                    textSearch: action.payload.textSearch,
                },
            }

        case actions.type.SEARCH_EVENT:
            return {
                ...state,
                ...{
                    lastTextSearch: state.textSearch,
                },
            }

        case actions.type.CHANGE_PAGE_SIZE:
            return {
                ...state,
                ...{
                    pageSize: action.payload.pageSize,
                    pageIndex: 1,
                },
            }

        case actions.type.CHANGE_CURRENT_PAGE:
            return {
                ...state,
                ...{
                    pageIndex: action.payload.pageIndex,
                },
            }

        case actions.type.UPDATE_SELECT_STATE_EVENT:
            return _handleUpdateSelectEventState(
                state,
                action.payload.eid,
                action.payload.selectState
            )

        case actions.type.UPDATE_SELECTED_EVENT:
            return _handleUpdateSelectedEvents(state, action.payload.events)

        case actions.type.UPDATE_STATE:
            return {
                ...state,
                ...action.payload.state,
            }

        default:
            return state
    }
}

export default reducer
